export var DatetimeSeparatorType;
(function (DatetimeSeparatorType) {
    DatetimeSeparatorType[DatetimeSeparatorType["Dot"] = 0] = "Dot";
    DatetimeSeparatorType[DatetimeSeparatorType["Line"] = 1] = "Line";
    DatetimeSeparatorType[DatetimeSeparatorType["Slash"] = 2] = "Slash";
    DatetimeSeparatorType[DatetimeSeparatorType["CHS"] = 3] = "CHS";
})(DatetimeSeparatorType || (DatetimeSeparatorType = {}));
